var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.SHIPS[_vm.type])?_c('div',{staticClass:"ship-img"},_vm._l((_vm.SHIPS[_vm.type]),function(part,i){return _c('div',{key:'part-' + i,staticClass:"ship-part",style:(_vm.tile(...part))})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }